import { ROUTE_NAMES } from './routeNames.const'

export const routeAdvisingReportPdf = {
  path: '/advising-report-pdf/:studyId?/:signature?',
  name: ROUTE_NAMES.advisingReportPdf,
  component: () =>
    import(
      /* webpackChunkName: "AdvisorReportPdf" */ 'src/pages/AdvisingReport/AdvisingReportPdf.vue'
    ),
  meta: {
    isPdf: true,
  },
}
